import Row from "@Containers/components/Row";
import IconPassengerClass from "@Icons/ticket/passengerClass/IconPassengerClass";
import PassengerClassSelect from "@CheckOrder/features/classPicker/components/PassengerClassSelect";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";
import AvailablePassengerClassesGroupType
    from "@CheckOrder/features/classPicker/types/AvailablePassengerClassesGroup.type";

interface PassengerClassesGroupProps {
    passengerId: number,
    passengerClassesGroup: AvailablePassengerClassesGroupType,
    handlePassengerClassSelect: (passengerClass: AvailablePassengerClassType) => () => void,
    isReturn: boolean,
}

function PassengerClassesGroup(props: PassengerClassesGroupProps) {
    const {
        passengerId,
        passengerClassesGroup,
        handlePassengerClassSelect,
        isReturn,
    } = props

    const {
        title,
        availablePassengerClasses,
        icon,
    } = passengerClassesGroup

    return (
        <>
            <Row className="passenger-class__group-title">
                <IconPassengerClass
                    {...icon}
                    width="24"
                    height="24"
                />
                {title}
            </Row>
            {availablePassengerClasses.map((passengerClass) => (
                <PassengerClassSelect
                    key={passengerClass.id}
                    passengerClass={passengerClass}
                    passengerId={passengerId}
                    handlePassengerClassSelect={handlePassengerClassSelect}
                    isReturn={isReturn}
                />
            ))}
        </>
    )
}

export default PassengerClassesGroup